import { render, staticRenderFns } from "./ShowQuestions.vue?vue&type=template&id=2b8c6d2c&"
import script from "./ShowQuestions.vue?vue&type=script&lang=js&"
export * from "./ShowQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports